(function() {
    "use strict";

    angular.module("inetconsFilterServices", [])
        .factory("accosHashUrlService", [
            "$timeout", "cookie",
            function ($timeout, cookie) {
                var url = cookie.get("accosUrlService");
                if (url) {
                    cookie.set("accosUrlService", url); // trigger change handler
                }

                return {
                    boardingSets: {},
                    amenitySets: {},
                    addBoardingSet: function(id, url, callbackChangeState) {
                        this.boardingSets[url] = {
                            id: id,
                            onChange: (typeof callbackChangeState === "function" ? callbackChangeState : function() {})
                        };
                        this.boardingSets[id] = url;
                    },
                    addAmenitySet: function(id, url, callbackChangeState) {
                        this.amenitySets[url] = {
                            id: id,
                            onChange: (typeof callbackChangeState === "function" ? callbackChangeState : function() {})
                        };
                        this.amenitySets[id] = url;
                    },

                    gotofilterUrl: function(boardingIds, amenityIds) {
                        var url = "", i;

                        boardingIds = this._sortBoardingIds(boardingIds);
                        for (i = 0; i < boardingIds.length; i++) {
                            var boardingPart = this.boardingSets[boardingIds[i]];
                            url += (boardingPart == undefined ? "" : "/" + boardingPart);
                        }

                        amenityIds = this._sortAmenityIds(amenityIds);
                        for (i = 0; i < amenityIds.length; i++) {
                            var amenityPart = this.amenitySets[amenityIds[i]];
                            url += (amenityPart == undefined ? "" : "/" + amenityPart);
                        }

                        url = url === "" ? "/" : url;

                        $timeout(function() {
                            cookie.set("accosUrlService", url);
                        });

                        return amenityIds;
                    },

                    parseUrl: function() {
                        var url = cookie.get("accosUrlService");

                        if (!url || url === "/") {
                            return undefined;
                        }

                        var parts = url.split("/");

                        var boardingIds = [];
                        var amenityIds = [];

                        var i, set;
                        var boardingSets = this.boardingSets;
                        for (i in boardingSets) {
                            if (boardingSets.hasOwnProperty(i)) {
                                set = boardingSets[i];
                                if (typeof set.onChange == "function") {
                                    set.onChange(false);
                                }
                            }
                        }
                        var amenitySets = this.amenitySets;
                        for (i in amenitySets) {
                            if (amenitySets.hasOwnProperty(i)) {
                                set = amenitySets[i];
                                if (typeof set.onChange == "function") {
                                    set.onChange(false);
                                }
                            }
                        }

                        for (var key in parts) {
                            if (parts.hasOwnProperty(key) && parts[key] != "") {

                                set = boardingSets[parts[key]];
                                if (set != undefined) {
                                    set.onChange(true);
                                    boardingIds.push(set.id);
                                    continue;
                                }

                                set = amenitySets[parts[key]];
                                if (set != undefined) {
                                    set.onChange(true);
                                    amenityIds.push(set.id);
                                }

                            }
                        }
                        return {
                            boardingIds: boardingIds,
                            amenityIds: amenityIds
                        }
                    },

                    removeCookie: function() {
                        cookie.remove("accosUrlService");
                    },

                    _sortBoardingIds: function(boardingIds) {
                        var sets = this.boardingSets;
                        var arrayOut = [];

                        for (var id in sets) {
                            // step through all {id: url} pares
                            if (sets.hasOwnProperty(id) && !isNaN(id)) {
                                if (boardingIds.indexOf(id) != -1) {
                                    arrayOut.push(id);
                                }
                            }
                        }

                        return arrayOut;
                    },
                    _sortAmenityIds: function(amenityIds) {
                        var sets = this.amenitySets;
                        var arrayOut = [];

                        for (var id in sets) {
                            // step through all {id: url} pares
                            if (sets.hasOwnProperty(id) && !isNaN(id)) {
                                if (amenityIds.indexOf(id) != -1) {
                                    arrayOut.push(id);
                                }
                            }
                        }

                        return arrayOut;
                    }
                }
            }
        ])
        .factory("accosUrlService", [
            "$window", "$http", "$log",
            function($window, $http, $log) {
                return {
                    accoTypeSets: {},
                    locationSets: {},
                    baseUrl: "",
                    accoTypeId: 0,
                    locationId: 0,
                    themeId: 0,

                    getUrl: function(accoTypeId, locationId, isPlace) {
                        accoTypeId = accoTypeId == undefined ? this.accoTypeId : accoTypeId;
                        locationId = locationId == undefined ? this.locationId : locationId;

                        var url = this.baseUrl;

                        var accoTypeUrl = this.accoTypeSets[accoTypeId];
                        var locationUrl = this.locationSets[locationId];

                        if (accoTypeUrl == undefined && locationUrl == undefined) {
                            return url + "?filter=true";
                        }

                        if (accoTypeUrl != undefined) {
                            url += "/" + accoTypeUrl;
                        }

                        if (locationUrl != undefined) {
                            url += "/" + locationUrl;
                        }

                        // -1 = "Buchbare Betriebe" = ein Thema kein AccoType
                        if (accoTypeId == -1 && isPlace !== true) {
                            url = this.baseUrl + "/" + accoTypeUrl;
                        }
                        if (accoTypeId == -1 && isPlace === true) {
                            if (locationUrl == undefined) {
                                return this.baseUrl + "/" + accoTypeUrl;
                            }
                            url = this.baseUrl + "/" + locationUrl;
                        }

                        return url;
                    },
                    goToUrl: function(url) {
                        url = url === "" || url == undefined ? "/" : url;
                        $window.location.href = url;
                    },

                    getNewCount: function(amenityIds, boardingIds, callback) {

                        var data = {
                            AreaIds: +this.locationId ? [+this.locationId] : null,
                            ThemeIds: this.themeId ? [this.themeId] : null,
                            Accotypes: +this.accoTypeId && +this.accoTypeId !== -1 ? [{
                                Id: +this.accoTypeId,
                                RatingFrom: 0,
                                RatingTo: 5
                            }] : null,
                            BoardingIds: boardingIds.length === 0 ? [] : boardingIds,
                            AmenityIds: amenityIds.length === 0 ? [] : amenityIds
                        };

                        $http.post("/api/enquiry/enquirycount", data)
                            .then(function (response) {
                                if (!response.data || !response.data.success) {
                                    throw response;
                                }

                                if (typeof callback == "function") {
                                    callback(response.data.count);
                                }
                            })
                            .catch(function (data) {
                                $log.error("error: accosUrlService.getNewCount() $http error", data, data.data);
                            });
                    }
                }
            }
        ])
        .directive("urlServiceAccoType", [
            "accosUrlService", "$window",
            function(accosUrlService, $window) {
                return {
                    link: function($scope, $element, $attr) {
                        var id = +$attr.accotypeId;
                        var url = (id === 0 ? undefined : $attr.accotypeUrl);

                        accosUrlService.accoTypeSets[id] = url;

                        $element.bind("click", function($event) {
                            var mq = $window.matchMedia("(max-width: 991px)");
                            if (mq.matches && !$element.hasClass("disabled")) {
                                $event.preventDefault();
                                if (id === -1) {
                                    accosUrlService.accoTypeId = -1;
                                    accosUrlService.locationId = 0;
                                    accosUrlService.themeId = +$attr.themeId;

                                    $scope.filter.AccoTypeId = -1;
                                    $scope.filter.ResortId = 0;
                                    $scope.filter.ThemeId = +$attr.themeId;
                                } else {
                                    accosUrlService.accoTypeId = id;
                                    accosUrlService.themeId = 0;
                                    // location stays as is
                                    $scope.filter.AccoTypeId = id;
                                    $scope.filter.ThemeId = 0;
                                    // resort stays as is
                                }

                                console.log($scope.filter, accosUrlService);

                                $scope.$eval($attr.urlServiceAccoType);
                            }
                        });
                    }
                }
            }
        ])
        .directive("urlServiceLocation", [
            "accosUrlService", "$window",
            function(accosUrlService, $window) {
                return {
                    link: function($scope, $element, $attr) {
                        var id = +$attr.locationId;
                        var url = (id === 0 ? undefined : $attr.locationUrl);

                        accosUrlService.locationSets[id] = url;

                        $element.bind("click", function($event) {
                            var mq = $window.matchMedia("(max-width: 991px)");
                            if (mq.matches && !$element.hasClass("disabled")) {
                                $event.preventDefault();
                                accosUrlService.locationId = id;
                                $scope.filter.ResortId = id;

                                $scope.$eval($attr.urlServiceLocation);
                            }
                        });
                    }
                }
            }
        ])
        .factory("cookie", [
            function () {
                return {
                    set: function(name, value) {
                        var now = new Date();
                        var time = now.getTime();
                        time += 1800 * 1000;
                        now.setTime(time);
                        $.cookie(name, value, { expires: now, domain: window.location.host, path: "/" });
                        // callback
                        if (typeof this.$handlers[name] === "function") this.$handlers[name]();
                    },
                    get: function(name) {
                        return $.cookie(name);
                    },
                    remove: function(name) {
                        this.set(name, null);
                    },
                    $handlers: {},
                    onChanged: function(name, callback) {
                        this.$handlers[name] = callback;
                    }
                };
            }
        ]);


})();
